import React from "react";
import { Spin } from "antd";
import "./spinner.styles.css";

const Spinner = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: props.height ? props.height : "100px",
      }}
    >
      <Spin size={props.size ? props.size : "large"} />
    </div>
  );
};

export default Spinner;
